import { nullable, object, string } from "../../../types/_types";

export const ArticleContributor = object({
	role: string(2),
	firstName: string().default(""),
	lastName: string().default(""),
	unnamedPersonsOnixCode: nullable(string()),
	productionId: string().nullable().optional(),
});
